export const WALLET_LINK_SENT = 'WALLET_LINK_SENT';
export const ERROR_SENDING_LINK = 'ERROR_SENDING_LINK';